<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="onClose()">
  <div class="relative w-full max-w-3xl bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col max-h-[92vh] overflow-hidden"
    (click)="$event.stopPropagation()">

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">store</span>
          {{ isEdit ? 'แก้ไขบริษัทผู้เช่า' : 'เพิ่มบริษัทผู้เช่า' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">ลานที่เลือก: {{ siteId }}</p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50 border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-5">
      <div *ngIf="isLoading()" class="py-10 text-center text-slate-400">
        <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
        กำลังโหลด...
      </div>

      <ng-container *ngIf="!isLoading() && formData">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อบริษัท <span class="text-rose-500">*</span></label>
            <input type="text" [(ngModel)]="formData.name" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-bold focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทบริษัท</label>
            <select [(ngModel)]="formData.clientTypeId" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50">
              <option [ngValue]="null">— ไม่ระบุ —</option>
              <option *ngFor="let t of clientTypeOptions" [ngValue]="t.id">{{ t.name }}</option>
            </select>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">บทบาท</label>
            <select [(ngModel)]="formData.clientRole" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50">
              <option *ngFor="let r of roleOptions" [value]="r.value">{{ r.label }}</option>
            </select>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">บริษัทแม่</label>
            <select [(ngModel)]="formData.parentClientId" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50">
              <option [ngValue]="null">— ไม่มี —</option>
              <option *ngFor="let p of parentClientOptions" [ngValue]="p.id">{{ p.label }}</option>
            </select>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สาขา</label>
            <input type="text" [(ngModel)]="formData.branch" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">โทรศัพท์</label>
            <input type="text" [(ngModel)]="formData.telephone" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Tax ID</label>
            <input type="text" [(ngModel)]="formData.taxId" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ผู้ติดต่อ</label>
            <input type="text" [(ngModel)]="formData.contact" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Limit Card</label>
            <input type="number" min="0" [(ngModel)]="formData.limitCard" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Limit Transaction</label>
            <input type="number" min="0" [(ngModel)]="formData.limitTransaction" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50" />
          </div>

          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ที่อยู่</label>
            <textarea rows="2" [(ngModel)]="formData.address" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50 resize-none"></textarea>
          </div>

          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
            <textarea rows="2" [(ngModel)]="formData.remark" [disabled]="isSaving()"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-50 resize-none"></textarea>
          </div>

          <div class="md:col-span-2 flex items-center gap-3">
            <input type="checkbox" id="canSelfManage" [(ngModel)]="formData.canSelfManage" [disabled]="isSaving()"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-200" />
            <label for="canSelfManage" class="text-sm font-semibold text-slate-600 dark:text-slate-300 cursor-pointer">
              บริษัทผู้เช่าจัดการเองได้
            </label>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="flex-none px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 hover:border-amber-400 hover:text-amber-600 cursor-pointer bg-transparent disabled:opacity-50 inline-flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex gap-3 ml-auto w-full sm:w-auto">
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 cursor-pointer bg-transparent disabled:opacity-50">
        ยกเลิก
      </button>
      <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
        class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50">
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingClient"
  [entityId]="itemId"
  title="ประวัติลูกค้าลาน (Client)"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
